<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form :model="search" label-position="top" label-width="" class = "el-form–label-top">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="Product Name">
              <el-select
                v-model="search.product_id"
                filterable
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="(item) in this.productList"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Project Manager"
              :span="6"
            >
              <el-select
                v-model="search.pm"
                filterable
                clearable
                style="width: 80%"
                :loading="loading1"
              >
                <el-option
                  v-for="(item) in pmList"
                  :value="item.label"
                  :key="item.label"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Progress">
              <el-select
                v-model="search.progress"
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="item in this.progress"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="16">
          <el-col :span="3">
            <el-button type="text" class="btn" @click="handleReset">
              Reset
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" class="btn" @click="getTaskList">
              Search
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always" title="Task List" style="width: 100%">
      <el-form>
        <el-table
          :data="taskList"
          border
          style="width: 100%"
          row-key="id"
          lazy
        >
          <el-table-column
            prop="taskName"
            label="Task Name"
            width="160"
            sortable
            fixed
          >
          </el-table-column>
          <el-table-column
            prop="productName"
            label="Product"
            width="120"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="projectName"
            label="Project Name"
            width="150"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="progressName"
            label="Progress"
            width="120"
            sortable
          >
          </el-table-column>

          <el-table-column
            prop="priorityName"
            label="Priority"
            width="120"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="assigneeName"
            label="Assignee"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="pm"
            label="Project Manager"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="Start Date"
            width="120"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="dueDate"
            label="Due Date"
            width="120"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="planHours"
            label="Plan Hours"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="adjustHours"
            label="Adjust Hours"
            width="120"
          >
            <template slot-scope="scope">
              <input type="text"
                     v-model="patchItem.adjust_hours"
                     v-if="isEdit === scope.$index"
              />
              <span v-else>{{scope.row.adjustHours}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="finalPlanHours"
            label="Final Plan Hours"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="currentSumHours"
            label="Total Actual Hours"
            :cell-class-name="setCellClass"
            width="160">
            <template slot-scope="scope">
              <span :style="getCellStyle(scope.row, scope.column, scope.$index)">
                {{ scope.row.totalActualHours }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            fixed="right"
            width="180">
            <template slot-scope="scope">
              <div v-if="isEdit === scope.$index">
                <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="handleSave(scope.$index, scope.row)">
                  Save
                </el-button>
                <el-button
                  size="small"
                  plain
                  @click="isEdit = -99">
                  Cancel
                </el-button>
              </div>
              <div v-else>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-right: 5px"
                  @click="handleEdit(scope.$index, scope.row)">
                  Edit
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="search.currentPage"
          :page-sizes="[10,20,50]"
          :total="search.totalPage"
          :page-size.sync="search.pageSize"
          prev-text="Previous"
          next-text="Next"
          style="margin-top: 4px"
          show-total
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-form>
    </el-card>


  </div>

</template>

<script>
import productApi from "@/api/product";
import taskApi from "@/api/tasks"
import userApi from "@/api/user";
import {PathName} from "@/constant/routeData";

export default {
  name: "taskList",
  data() {
    return {
      productList:[],
      taskList:[],
      reqs:[],
      progressList:["Not started","In progress","Completed"],
      d_statusList:['To Do','Designing','Developing','Testing','Debug/Bug fixing','Releasing','Archive'],
      pmList:[],
      loading1: false,
      editIndex: -1,
      isEdit: -99,
      patchItem: {
        adjust_hours: 0
      },
      search: {
        product_id: '',
        assign_to_id: '',
        pm:'',
        progress: '',
        pageSize: 10,
        totalPage: 0,
      },
      // progress: [{'value':0,'name':'Not started'},{'value':50,'name':'In progress'},{'value':100,'name':'Completed'}],
      progress: ['Not started','In progress','Completed'],
    }
  },
  methods:{
    setCellClass({ row, column }) {
      if (column.property === 'currentSumHours') {
        console.log(row.totalActualHours)
        const diff = row.totalActualHours - row.finalPlanHours;
        const diff1 = row.finalPlanHours - row.totalActualHours;
        const threshold = row.finalPlanHours * 0.2;
        if (diff > 0) {
          return  { color: 'red' };
        }
        if (diff === 0) {
          return { color: 'black' };
        }
        if (diff1 < threshold) {
          return { color: 'orange' };
        }
      }
      return '';
    },
    getCellStyle(row, column) {
      if (column.property === 'currentSumHours') {
        const diff =  row.totalActualHours - row.finalPlanHours;
        const diff1 =  row.finalPlanHours - row.totalActualHours;
        const threshold = row.finalPlanHours * 0.2;
        if (diff > 0) {
          return  { color: 'red' };
        }
        if (diff === 0) {
          return { color: 'black' };
        }
        if (diff1 < threshold) {
          return { color: 'orange' };
        }

      }
      return {};
    },
    getTaskList(){
      let para = {}
      para['offset'] = this.search.pageSize * (this.search.currentPage -1)
      para['limit'] = this.search.pageSize
      if (this.search.product_id) {
        para['product_id'] = this.search.product_id
      }
      if (this.search.progress) {
        para['progress'] = this.search.progress
      }
      if (this.search.assign_to_id) {
        para['assign_to_id'] = this.search.assign_to_id
      }
      if (this.search.pm) {
        para['pm'] = this.search.pm
      }
      taskApi.getAllTasks(para).then(
        res => {
          this.taskList = res.data.data
          this.search.totalPage = res.data.total
        }
      )
    },
    handleSave(index, row) {
      let para = {id: row.id}
      let data = this.patchItem
      data['adjust_hours'] = this.patchItem.adjust_hours
      taskApi.updateTask(para, data).then(resp=>{
        this.$message.success(
          {
            message: resp['msg'],
            type: "success"
          }
        )
        this.getTaskList()
      })
      this.isEdit = -99
    },
    handleEdit(index, row) {
      this.patchItem.adjust_hours = row.adjust_hours
      this.isEdit = index
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.pmList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.productList.push({value: product.id, label: product.name})
          }
        }
      )
    },
    handleReset() {
      this.search.assign_to_id = null
      this.search.project_id = null
      this.search.progress = null
    },
    handleSizeChange(val) {
      this.search.pageSize = val
      this.getTaskList()
      // 在此刷新数据
    },
    handleCurrentChange(val){
      this.search.currentPage = val
      this.getTaskList()
    },
    handleEditRouter(index,row) {
      const id = row.id
      let routeData = this.$router.resolve({name: PathName.ProjectEdit, query:{id:id}});
      window.open(routeData.href, '_blank');
    },
    handlePreviewRouter(index, row) {
      const id = row.id
      let routeData = this.$router.resolve({name: PathName.ProjectPreview, query:{id:id}});
      window.open(routeData.href, '_blank');
    },
  },
  mounted(){
    this.getSelects()
    this.getTaskList()
  },
}



</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}
.el-form–label-top {
  text-align: left !important;
}

</style>
